import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F4F4F5',
  200: '#E4E4E7',
  300: '#D4D4D8',
  400: '#A1A1AA',
  500: '#71717A',
  600: '#52525B',
  700: '#3F3F46',
  800: '#27272A',
  900: '#09090B',
};

const PRIMARY = {
  lighter: '#FFE4E6',
  light: '#FDA4AF',
  main: '#E11D48',
  dark: '#9F1239',
  darker: '#4C0519',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#EDE9FE',
  light: '#C4B5FD',
  main: '#7C3AED',
  dark: '#5B21B6',
  darker: '#2E1065',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#DBEAFE',
  light: '#93C5FD',
  main: '#3B82F6',
  dark: '#1D4ED8',
  darker: '#1E3A8A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#DCFCE7',
  light: '#86EFAC',
  main: '#22C55E',
  dark: '#15803D',
  darker: '#14532D',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FEF9C3',
  light: '#FDE047',
  main: '#EAB308',
  dark: '#A16207',
  darker: '#713F12',
  contrastText: GREY[900],
};

const ERROR = {
  lighter: '#FEE2E2',
  light: '#FCA5A5',
  main: '#EF4444',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#fff',
};

const lightPalette = {
  mode: 'light',
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.16),
  text: {
    primary: GREY[900],
    secondary: GREY[600],
    disabled: GREY[400],
  },
  background: {
    paper: '#FFFFFF',
    default: '#FAFAFA',
    neutral: GREY[100],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(PRIMARY.main, 0.12),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(PRIMARY.main, 0.16),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const darkPalette = {
  mode: 'dark',
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.16),
  text: {
    primary: '#F9FAFB',
    secondary: GREY[400],
    disabled: GREY[600],
  },
  background: {
    paper: '#18181B',
    default: '#09090B',
    neutral: '#27272A',
  },
  action: {
    active: GREY[500],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(PRIMARY.main, 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(PRIMARY.main, 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export const getPalette = (mode) => (mode === 'dark' ? darkPalette : lightPalette);

export default lightPalette;
